module.exports = __webpack_public_path__ + "static/img/moreFutureDevelopment.1c2e877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moreFutureDevelopment.png
// module id = ws/1
// module chunks = 2